import React from 'react';
import HeaderNavigation from '../../headers/HeaderNavigation/HeaderNavigation';
import UserInfo from '../../headers/UserInfo/UserInfo';
import PageHeader from '../../headers/PageHeader/PageHeader';
import PageName from '../../headers/PageName/PageName';

function PlansHeader() {
    return <PageHeader
        leftPart={
            <React.Fragment>
                <HeaderNavigation />
                <PageName name="Subscription" />
            </React.Fragment>
        }
        rightPart={
            <React.Fragment>
                <UserInfo/>
            </React.Fragment>
        }
    />;
}

export default PlansHeader;